/* =================================================================
   Horma Real — Medidor de talla con cámara
   app.js (lógica). Va junto a index.html.
   ================================================================= */

/* ---------- CONFIG: el otro asistente conecta Shopify aquí (INTACTO) ---------- */
const CONFIG = {
  STORE: 'hormareal.com',
  BRAND: 'Rómulo',                 // etiqueta de marca en el resultado: "Tu talla Rómulo es 38"
  /* v1: vacío (solo muestra la talla en pantalla).
     Para conectar el catálogo después, pon p.ej. 'https://hormareal.com/collections/all'
     La opción de talla en Shopify se llama "Talla" (unificada el 28-oct-2026) (valores 33-45 = escala propia de Rómulo / talla colombiana). */
  SHOP_BASE: '',
  PARAM_TALLA: 'filter.v.option.Talla'
};

/* TEMPORAL — modo debug. Poner true para ver footCm/mmPerPx en el resultado (validación). */
var DEBUG = false;

/* ===== TABLAS DE TALLAJE — Calzado Rómulo (sistema COL, por género). PRINCIPAL = COL.
   cm = longitud de pie de referencia para esa talla. El match toma la talla cuyo cm está
   MÁS CERCA del pie medido; si hay empate, se elige la MAYOR (tieBreakRule del cliente).
   EU/US son equivalencias internacionales APROXIMADAS derivadas de la longitud del pie
   (no son tablas oficiales de la marca). ===== */
/* 19-oct-2026: igualada a la tabla canónica (hr-beta-sizeguide, hr-size-guide, la tabla de esta misma página y
   hr-sizefinder.js). Antes dama iba en pasos de 1 cm (36=24,0) y un pie de 24 cm salía 36 en vez de 38.
   Si cambia una, cambien todas.
   3-nov-2026: dama rehecha con la plantilla medida en la tienda (Soft 2 y Samanta): cada cm es la mitad del rango de pie
   de la guía (34 = 21,8–22,4 … 40 = 25,7–26,3), así la talla más cercana cae en el mismo rango. Caballero sin cambios. */
const TABLAS = {
  mujer: [
    {size:33, cm:21.4},{size:34, cm:22.1},{size:35, cm:22.8},{size:36, cm:23.5},{size:37, cm:24.2},
    {size:38, cm:24.8},{size:39, cm:25.4},{size:40, cm:26.0},{size:41, cm:26.7}
  ],
  hombre: [
    {size:36, cm:24.0},{size:37, cm:24.5},{size:38, cm:25.0},{size:39, cm:25.5},{size:40, cm:26.0},
    {size:41, cm:26.5},{size:42, cm:27.0},{size:43, cm:27.5},{size:44, cm:28.5},{size:45, cm:29.0}
  ]
};
var FIT = {exact:0.15, close:0.35};   // fitLabels del cliente (|diff_cm|)

/* talla con cm más cercano al pie medido; empate → talla MAYOR */
function matchSize(footCm, table){
  var best=table[0], bd=Math.abs(footCm-table[0].cm);
  for(var i=1;i<table.length;i++){
    var d=Math.abs(footCm-table[i].cm);
    if(d < bd - 1e-9 || (Math.abs(d-bd)<=1e-9 && table[i].size>best.size)){ best=table[i]; bd=d; }
  }
  return best;
}
/* equivalencias internacionales aprox. desde la longitud del pie (punto París + offset US) */
function equiv(cm, esHombre){
  var eu=Math.round((cm+1.5)*1.5);
  var us=Math.round((eu-(esHombre?33:30.5))*2)/2;
  if(us<1) us=1;
  return {eu:eu, us:us};
}

const PAPEL = {
  carta:{largo:279.4, corto:215.9},
  a4:   {largo:297.0, corto:210.0}
};

/* ---------- Carrusel de instrucciones ---------- */
const SLIDES = [
  {t:'Coloca el pie junto a la hoja',
   p:'Descalzo, sobre piso duro. Pon una hoja Carta o A4 al lado del pie, en el mismo plano. Talón y hoja apoyados contra la pared.',
   svg:illusRoom()},
  {t:'Teléfono en paralelo',
   p:'Sostén el teléfono justo encima, paralelo al piso, y toma la foto. No lo inclines.',
   svg:illusPhone()},
  {t:'Pie y hoja completos',
   p:'Asegúrate de que se vean el pie entero y toda la hoja, sin sombras fuertes encima.',
   svg:illusTop()}
];

const ST = {slide:0, img:null, cardPts:[], footPts:[], scale:{}, stream:null, debug:null};

/* ---------- ilustraciones SVG ---------- */
function illusRoom(){return '<svg viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg">'+
'<rect width="300" height="300" fill="#eef0f1"/>'+
'<polygon points="0,0 300,0 300,150 0,150" fill="#f6f7f8"/>'+
'<polygon points="0,150 300,150 300,300 0,300" fill="#d8c3a0"/>'+
'<line x1="0" y1="150" x2="300" y2="150" stroke="#c4b289" stroke-width="2"/>'+
'<line x1="150" y1="0" x2="150" y2="150" stroke="#2b2b2b" stroke-width="3" stroke-dasharray="9 8"/>'+
'<polygon points="150,150 235,150 215,250 95,250" fill="none" stroke="#2b2b2b" stroke-width="3" stroke-dasharray="9 8"/>'+
'<polygon points="150,158 215,158 205,238 150,238" fill="#ffffff" stroke="#bdbdc2" stroke-width="2"/>'+
'<ellipse cx="115" cy="205" rx="22" ry="46" fill="#f0d9c4" stroke="#2b2b2b" stroke-width="3"/>'+
'<circle cx="100" cy="168" r="6" fill="#f0d9c4" stroke="#2b2b2b" stroke-width="2"/>'+
'<circle cx="112" cy="164" r="6.5" fill="#f0d9c4" stroke="#2b2b2b" stroke-width="2"/>'+
'<circle cx="125" cy="166" r="6" fill="#f0d9c4" stroke="#2b2b2b" stroke-width="2"/></svg>';}
function illusPhone(){return '<svg viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg">'+
'<rect width="300" height="300" fill="#f6f7f8"/>'+
'<polygon points="0,205 300,205 300,300 0,300" fill="#d8c3a0"/>'+
'<line x1="0" y1="205" x2="300" y2="205" stroke="#c4b289" stroke-width="2"/>'+
'<rect x="118" y="150" width="64" height="34" rx="7" fill="#2b2b2b"/>'+
'<rect x="124" y="156" width="52" height="22" rx="3" fill="#7fb0e0"/>'+
'<path d="M120 150 q-14 -38 -8 -78" stroke="#cfa98a" stroke-width="16" fill="none" stroke-linecap="round"/>'+
'<path d="M180 150 q14 -38 8 -78" stroke="#cfa98a" stroke-width="16" fill="none" stroke-linecap="round"/>'+
'<rect x="128" y="40" width="44" height="44" rx="10" fill="#3b4a63"/>'+
'<rect x="98" y="206" width="44" height="22" rx="5" fill="#ffffff" stroke="#bdbdc2" stroke-width="2"/>'+
'<ellipse cx="178" cy="232" rx="16" ry="30" fill="#f0d9c4" stroke="#2b2b2b" stroke-width="2.5"/>'+
'<ellipse cx="120" cy="248" rx="15" ry="28" fill="#f0d9c4" stroke="#2b2b2b" stroke-width="2.5"/></svg>';}
function illusTop(){return '<svg viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg">'+
'<rect width="300" height="300" fill="#d8c3a0"/>'+
'<rect x="46" y="58" width="120" height="170" rx="4" fill="#ffffff" stroke="#bdbdc2" stroke-width="3"/>'+
'<ellipse cx="210" cy="150" rx="40" ry="92" fill="#f0d9c4" stroke="#2b2b2b" stroke-width="3"/>'+
'<circle cx="188" cy="74" r="11" fill="#f0d9c4" stroke="#2b2b2b" stroke-width="2.5"/>'+
'<circle cx="206" cy="66" r="12" fill="#f0d9c4" stroke="#2b2b2b" stroke-width="2.5"/>'+
'<circle cx="224" cy="70" r="11" fill="#f0d9c4" stroke="#2b2b2b" stroke-width="2.5"/>'+
'<circle cx="239" cy="82" r="9" fill="#f0d9c4" stroke="#2b2b2b" stroke-width="2.5"/></svg>';}

/* ---------- navegación entre pantallas ---------- */
function goScreen(id){
  if(id!=='sc-live' && ST.stream) stopCamera();   // si salimos de la cámara en vivo, liberar
  document.querySelectorAll('.screen').forEach(function(s){s.classList.remove('on');});
  document.getElementById(id).classList.add('on');
  if(id==='sc-card') initCanvas('card');
  if(id==='sc-foot') initCanvas('foot');
}
function resetAll(){
  stopCamera();
  ST.img=null; ST.cardPts=[]; ST.footPts=[]; ST.slide=0; ST.debug=null;
  renderSlide(); goScreen('sc-intro');
}
/* salir del medidor y volver a la tienda. Si vino de una página del sitio
   (referrer del mismo dominio), regresa exactamente a esa página; si se abrió
   por QR/escaneo sin referrer, vuelve a la portada de la tienda. */
function exitScanner(){
  stopCamera();
  var ref = document.referrer || '';
  if (ref && ref.indexOf(location.origin) === 0) {
    window.location.href = ref;
    return;
  }
  window.location.href = location.origin + '/';
}
function goSlide(i){ST.slide=i;renderSlide();}
function renderSlide(){
  var s=SLIDES[ST.slide];
  document.getElementById('illus').innerHTML=s.svg;
  document.getElementById('slide-t').textContent=s.t;
  document.getElementById('slide-p').textContent=s.p;
  document.getElementById('dots').innerHTML=SLIDES.map(function(_,i){return '<span class="dot'+(i===ST.slide?' on':'')+'"></span>';}).join('');
  document.getElementById('b-prev').disabled=ST.slide===0;
  document.getElementById('b-next').textContent=ST.slide===SLIDES.length-1?'¡Entiendo!':'Siguiente';
}
function slidePrev(){if(ST.slide>0){ST.slide--;renderSlide();}}
function slideNext(){
  if(ST.slide<SLIDES.length-1){ST.slide++;renderSlide();}
  else goScreen('sc-options');
}

/* ================= CÁMARA EN VIVO ================= */
function openLiveCamera(){
  requestOrientationPermission();                 // pedir nivel (iOS necesita gesto, este onclick lo es)
  if(!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia){ return triggerFallback(); }
  navigator.mediaDevices.getUserMedia({video:{facingMode:{ideal:'environment'}}, audio:false})
    .then(function(stream){
      ST.stream=stream;
      var v=document.getElementById('live-video');
      v.srcObject=stream;
      var pr=v.play(); if(pr&&pr.catch) pr.catch(function(){});
      goScreen('sc-live');
    })
    .catch(function(){ triggerFallback(); });      // permiso negado / sin cámara → input capture del sistema
}
function triggerFallback(){
  toast('Abriendo cámara del sistema…');
  document.getElementById('fallback-capture').click();
}
function liveBack(){ stopCamera(); goScreen('sc-capture'); }
function stopCamera(){
  if(ST.stream){ ST.stream.getTracks().forEach(function(t){t.stop();}); ST.stream=null; }
  window.removeEventListener('deviceorientation', onOrient);
}
function captureFrame(){
  var v=document.getElementById('live-video');
  var vw=v.videoWidth, vh=v.videoHeight;
  if(!vw||!vh){ toast('La cámara aún carga…'); return; }
  var c=document.createElement('canvas'); c.width=vw; c.height=vh;
  c.getContext('2d').drawImage(v,0,0,vw,vh);
  var img=new Image();
  img.onload=function(){ ST.img=img; ST.cardPts=[]; ST.footPts=[]; goScreen('sc-card'); };
  img.src=c.toDataURL('image/jpeg',0.92);
}
function requestOrientationPermission(){
  try{
    if(typeof DeviceOrientationEvent!=='undefined' && typeof DeviceOrientationEvent.requestPermission==='function'){
      DeviceOrientationEvent.requestPermission().then(function(s){ if(s==='granted') window.addEventListener('deviceorientation', onOrient); }).catch(function(){});
    } else if(window.DeviceOrientationEvent){
      window.addEventListener('deviceorientation', onOrient);
    }
  }catch(e){}
}
function onOrient(e){
  if(e.beta===null && e.gamma===null) return;
  updateLevel(e.beta||0, e.gamma||0);
}
function updateLevel(beta,gamma){
  /* cenital = teléfono paralelo al piso, pantalla arriba → beta≈0 y gamma≈0 */
  var dot=document.getElementById('level-dot');
  if(!dot) return;
  var tol=8;
  var flat=(Math.abs(beta)<=tol && Math.abs(gamma)<=tol);
  var R=20;
  var x=Math.max(-R,Math.min(R, gamma/30*R));
  var y=Math.max(-R,Math.min(R, beta/30*R));
  dot.style.transform='translate('+Math.round(x)+'px,'+Math.round(y)+'px)';
  var lvl=document.getElementById('level'),msg=document.getElementById('live-msg'),sh=document.getElementById('shutter');
  if(flat){ lvl.classList.add('ok'); sh.classList.add('ok'); msg.textContent='¡Perfecto! Toca para tomar la foto'; }
  else    { lvl.classList.remove('ok'); sh.classList.remove('ok'); msg.textContent='Sostén el teléfono plano y apunta al piso'; }
}

/* ---------- foto desde archivo / galería / fallback ---------- */
function onPhoto(e){
  var f=e.target.files&&e.target.files[0];
  if(!f) return;
  var r=new FileReader();
  r.onload=function(ev){var i=new Image();i.onload=function(){ST.img=i;ST.cardPts=[];ST.footPts=[];goScreen('sc-card');};i.src=ev.target.result;};
  r.readAsDataURL(f);
}

/* ---------- canvas de marcado ---------- */
var COLORS=['#1d9e75','#e2b04b','#378add','#c8372a'];
function initCanvas(kind){
  var cv=document.getElementById(kind==='card'?'cv-card':'cv-foot');
  var wrap=cv.parentElement.getBoundingClientRect();
  var maxW=wrap.width, maxH=wrap.height;
  var ratio=ST.img.naturalWidth/ST.img.naturalHeight;
  var w=maxW, h=w/ratio;
  if(h>maxH){h=maxH;w=h*ratio;}
  var dpr=Math.min(window.devicePixelRatio||1,2);
  cv.width=Math.round(w*dpr); cv.height=Math.round(h*dpr);
  cv.style.width=w+'px'; cv.style.height=h+'px';
  ST.scale={cv:cv,w:w,h:h,dpr:dpr};
  draw(kind);
  if(kind==='card'){
    var zt=document.getElementById('card-zoom'); zt.style.display='block';
    setTimeout(function(){zt.style.display='none';},3200);
  }
  cv.onclick=function(ev){handleTap(kind,ev);};
  updateUI(kind);
}
/* tap → coordenada normalizada (0–1) relativa a la imagen mostrada.
   El canvas se dibuja llenando todo su tamaño CSS, así que (clientX-left)/width
   mapea linealmente a la imagen. Es invariante a escala/DPR. */
function toImgCoords(ev){
  var cv=ST.scale.cv, r=cv.getBoundingClientRect();
  return {x:(ev.clientX-r.left)/r.width, y:(ev.clientY-r.top)/r.height};
}
function handleTap(kind,ev){
  var arr=kind==='card'?ST.cardPts:ST.footPts;
  var max=kind==='card'?4:2;
  if(arr.length>=max) return;
  arr.push(toImgCoords(ev));
  draw(kind); updateUI(kind);
}
function undo(kind){
  var arr=kind==='card'?ST.cardPts:ST.footPts;
  arr.pop(); draw(kind); updateUI(kind);
}
function draw(kind){
  var cv=ST.scale.cv, w=ST.scale.w, h=ST.scale.h, dpr=ST.scale.dpr;
  var x=cv.getContext('2d');
  x.setTransform(dpr,0,0,dpr,0,0);
  x.clearRect(0,0,w,h);
  x.drawImage(ST.img,0,0,w,h);
  if(kind==='foot' && ST.cardPts.length===4){
    var ord=orderByAngle(ST.cardPts);
    x.beginPath();
    ord.forEach(function(p,i){var X=p.x*w,Y=p.y*h;i?x.lineTo(X,Y):x.moveTo(X,Y);});
    x.closePath(); x.strokeStyle='rgba(29,158,117,.5)'; x.lineWidth=2; x.stroke();
  }
  var arr=kind==='card'?ST.cardPts:ST.footPts;
  if(kind==='card'&&arr.length>1){
    var o2=orderByAngle(arr);
    x.beginPath();
    o2.forEach(function(p,i){var X=p.x*w,Y=p.y*h;i?x.lineTo(X,Y):x.moveTo(X,Y);});
    if(arr.length===4)x.closePath();
    x.strokeStyle='rgba(200,55,42,.6)';x.lineWidth=2;x.stroke();
  }
  if(kind==='foot'&&arr.length===2){
    x.beginPath();x.moveTo(arr[0].x*w,arr[0].y*h);x.lineTo(arr[1].x*w,arr[1].y*h);
    x.strokeStyle='#c8372a';x.lineWidth=3;x.setLineDash([8,5]);x.stroke();x.setLineDash([]);
  }
  arr.forEach(function(p,i){
    var X=p.x*w,Y=p.y*h;
    var col=kind==='card'?COLORS[i]:(i===0?'#378add':'#c8372a');
    x.beginPath();x.arc(X,Y,15,0,7);x.fillStyle=col;x.fill();
    x.strokeStyle='#fff';x.lineWidth=3;x.stroke();
    x.fillStyle='#fff';x.font='bold 13px sans-serif';x.textAlign='center';x.textBaseline='middle';
    x.fillText(kind==='card'?(i+1):(i===0?'T':'P'),X,Y);
  });
}
function updateUI(kind){
  if(kind==='card'){
    var n=ST.cardPts.length;
    var h1=['Toca cualquier esquina de la hoja (1 de 4)','Toca otra esquina (2 de 4)','Toca otra esquina (3 de 4)','Toca la última esquina (4 de 4)','¡Hoja calibrada! Continúa'];
    document.getElementById('card-hint').textContent=h1[n];
    document.getElementById('card-dots').innerHTML=[0,1,2,3].map(function(i){return '<span class="pdot'+(i<n?' on':'')+'"></span>';}).join('');
    document.getElementById('card-next').style.display=n===4?'flex':'none';
  }else{
    var m=ST.footPts.length;
    var h2=['Toca el punto más trasero del talón','Toca la punta del dedo más largo','¡Pie marcado! Ver resultado'];
    document.getElementById('foot-hint').textContent=h2[m];
    document.getElementById('foot-dots').innerHTML=[0,1].map(function(i){return '<span class="pdot'+(i<m?' on':'')+'"></span>';}).join('');
    document.getElementById('foot-next').style.display=m===2?'flex':'none';
  }
}

/* ---------- geometría ---------- */
function px(p){ return {x:p.x*ST.img.naturalWidth, y:p.y*ST.img.naturalHeight}; }
function eucl(a,b){ return Math.hypot(b.x-a.x, b.y-a.y); }
/* ordena puntos por ángulo alrededor del centroide → quedan en orden cíclico
   (los índices opuestos 0-2 y 1-3 son diagonales; los consecutivos son lados). */
function orderByAngle(ptsNorm){
  var cx=0,cy=0; ptsNorm.forEach(function(p){cx+=p.x;cy+=p.y;}); cx/=ptsNorm.length; cy/=ptsNorm.length;
  return ptsNorm.slice().sort(function(a,b){return Math.atan2(a.y-cy,a.x-cx)-Math.atan2(b.y-cy,b.x-cx);});
}
/* escala robusta: promedia 3 estimaciones (lados largos, lados cortos, diagonales) */
function computeScale(cardPtsNorm, papel){
  var P=orderByAngle(cardPtsNorm).map(px);
  var sides=[]; for(var i=0;i<4;i++){ sides.push(eucl(P[i],P[(i+1)%4])); }
  var srt=sides.slice().sort(function(a,b){return a-b;});
  var shortPx=(srt[0]+srt[1])/2, longPx=(srt[2]+srt[3])/2;
  var diagPx=(eucl(P[0],P[2])+eucl(P[1],P[3]))/2;
  var realDiag=Math.sqrt(papel.largo*papel.largo+papel.corto*papel.corto);
  var estLong=papel.largo/longPx, estShort=papel.corto/shortPx, estDiag=realDiag/diagPx;
  return {mmPerPx:(estLong+estShort+estDiag)/3, diagPx:diagPx, longPx:longPx, shortPx:shortPx, estLong:estLong, estShort:estShort, estDiag:estDiag};
}

/* ---------- cálculo ---------- */
function calcular(){
  var papelKey=document.querySelector('input[name=papel]:checked').value;
  var genero=document.querySelector('input[name=genero]:checked').value;
  var P=PAPEL[papelKey];
  var sc=computeScale(ST.cardPts, P);
  var footPx=eucl(px(ST.footPts[0]), px(ST.footPts[1]));
  var footMm=footPx*sc.mmPerPx;
  var footCm=footMm/10;
  ST.debug={footCm:footCm, mmPerPx:sc.mmPerPx, footPx:footPx, diagPx:sc.diagPx,
            longPx:sc.longPx, shortPx:sc.shortPx, estLong:sc.estLong, estShort:sc.estShort, estDiag:sc.estDiag, papel:papelKey};

  var esHombre=(genero==='masculino');
  var table=esHombre?TABLAS.hombre:TABLAS.mujer;   // unisex/dama → tabla de dama
  var row=matchSize(footCm, table);
  pintarResultado(row, footCm, genero, table, esHombre);
  goScreen('sc-result');
}
function pintarResultado(row, footCm, genero, table, esHombre){
  var gLabel=genero==='femenino'?'Dama':(genero==='masculino'?'Caballero':'Unisex');
  var eq=equiv(row.cm, esHombre);
  document.getElementById('r-talla').textContent=row.size;
  document.getElementById('r-title').textContent='Su talla '+CONFIG.BRAND+' es '+row.size;
  document.getElementById('r-sub').textContent=gLabel+' · pie de '+footCm.toFixed(1)+' cm';
  document.getElementById('r-cm').textContent=footCm.toFixed(1);
  document.getElementById('r-eu').textContent='≈'+eq.eu;
  document.getElementById('r-us').textContent='≈'+eq.us;

  var ad=Math.abs(footCm-row.cm);
  var minRow=table[0], maxRow=table[table.length-1];
  var note;
  if(footCm < minRow.cm - FIT.close && row.size===minRow.size){
    note='Tu pie ('+footCm.toFixed(1)+' cm) es más pequeño que nuestra talla más pequeña, la <b>'+minRow.size+'</b>. Te mostramos la <b>'+minRow.size+'</b>.';
  } else if(footCm > maxRow.cm + FIT.close && row.size===maxRow.size){
    note='Tu pie ('+footCm.toFixed(1)+' cm) es más grande que nuestra talla más grande, la <b>'+maxRow.size+'</b>. Te mostramos la <b>'+maxRow.size+'</b>.';
  } else if(ad<=FIT.exact){
    note='La talla <b>'+row.size+'</b> te queda exacta. Mide ambos pies y usa el mayor.';
  } else if(ad<=FIT.close){
    note='La talla <b>'+row.size+'</b> es tu mejor opción. Mide ambos pies y usa el mayor.';
  } else {
    note='Tu pie queda entre tallas; te recomendamos la <b>'+row.size+'</b> (redondeando hacia arriba). Mide ambos pies y usa el mayor.';
  }
  if(genero==='unisex') note+=' Para mayor precisión, elige Dama o Caballero.';
  document.getElementById('r-note').innerHTML=note;

  var dbg=document.getElementById('r-debug');
  if(DEBUG && ST.debug){
    var d=ST.debug;
    dbg.style.display='block';
    dbg.innerHTML='DEBUG (temporal) · papel: '+d.papel+
      '<br>footCm = <b>'+d.footCm.toFixed(2)+'</b> · mmPerPx = <b>'+d.mmPerPx.toFixed(4)+'</b>'+
      '<br>footPx = '+Math.round(d.footPx)+' · diagPx = '+Math.round(d.diagPx)+
      '<br>ladoLargo = '+Math.round(d.longPx)+'px · ladoCorto = '+Math.round(d.shortPx)+'px'+
      '<br>estLargo='+d.estLong.toFixed(4)+' estCorto='+d.estShort.toFixed(4)+' estDiag='+d.estDiag.toFixed(4);
  } else { dbg.style.display='none'; }

  document.getElementById('r-shop').onclick=function(){irAComprar(row.size,genero,footCm);};
}

/* ---------- integración Shopify (punto de conexión) ---------- */
function irAComprar(talla,genero,cm){
  var payload={type:'horma-real:talla', talla:talla, genero:genero, cm:Number(cm.toFixed(1))};
  try{ localStorage.setItem('hr_talla', JSON.stringify(payload)); }catch(e){}
  try{ if(window.parent && window.parent!==window) window.parent.postMessage(payload,'*'); }catch(e){}
  if(CONFIG.SHOP_BASE){
    var u=new URL(CONFIG.SHOP_BASE);
    u.searchParams.set(CONFIG.PARAM_TALLA, talla);
    (window.top||window).location.href=u.toString();
  }else{
    toast('Talla '+talla+' '+CONFIG.BRAND+' guardada');
  }
}
function toast(msg){
  var t=document.getElementById('toast');
  t.textContent=msg; t.classList.add('on');
  setTimeout(function(){t.classList.remove('on');},2200);
}

/* ---------- bloquear zoom (pellizco y gesto) — no se comporta como imagen ---------- */
document.addEventListener('touchmove', function(e){ if(e.touches && e.touches.length>1) e.preventDefault(); }, {passive:false});
document.addEventListener('gesturestart', function(e){ e.preventDefault(); });
document.addEventListener('gesturechange', function(e){ e.preventDefault(); });

/* init */
renderSlide();
